import { useEffect, useContext, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Link } from 'react-router-dom';
import Lottie from "lottie-react";

import { DataContext } from 'providers/data';
import { handleSomeProductRF } from 'core/dataProductsRF';

import { Box } from '@mui/material';

import Menu from 'components/views/Menu';
import News from 'components/views/News';
import NavTitle from 'components/views/NavTitle';
import ModalClube from 'components/views/ModalClube';
import VehicleData from 'components/views/VehicleData';
import CarouselCars from 'components/views/CarouselCars';
import { ContentBodyPage, ContentNewsPage, Banner } from 'components/views/ContainersPage';

import { ContentNewsMobile, LinkButton, BoxAnimationBanner } from './styles';

import BannerClub from 'assets/images/banners/desk/banner-club-desk.png';
import BannerUpgrade from 'assets/images/banners/desk/banner-upgrade-desk.png';
import BannerUpgradeRf from 'assets/images/banners/desk/banner-upgrade-rf-desk.png';
import BannerServicesAdd from 'assets/images/banners/desk/banner-services-add-desk.png';
import BannerDadosAtualizadosDesk from 'assets/images/banners/desk/banner-dados-atualizados-desk.png';
import BannerDadosAtualizadosMob from 'assets/images/banners/mob/banner-dados-atualizados-mob.png';

import BannerClubMb from 'assets/images/banners/mob/banner-club-mob.png';
import BannerUpgradeMb from 'assets/images/banners/mob/banner-upgrade-mob.png';
import BannerServicesAddMb from 'assets/images/banners/mob/banner-services-add-mob.png';

import { ReactComponent as IcRemoveDoubts } from 'assets/icons/ic-remove-doubts.svg';

import { ReactComponent as IcInsta } from 'assets/icons/social-media/ic-insta.svg';
import { ReactComponent as IcFace } from 'assets/icons/social-media/ic-face.svg';
import { ReactComponent as IcBlog } from 'assets/icons/social-media/ic-blog.svg';
import { ReactComponent as IcTwitter } from 'assets/icons/social-media/ic-twitter.svg';
import { ReactComponent as IcYoutube } from 'assets/icons/social-media/ic-youtube.svg';

import bannerHome from 'assets/animation/banner_home.json';
import bannerHomeMob from 'assets/animation/banner_home_mob.json';

const Home = () => {
    const [isProductRF, setIsProductRF] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);

    const { selectedCar, blockClick } = useContext(DataContext);

    const bannersDesk = () => {
        const slides = [
            <BoxAnimationBanner>
                <Link to='/central-de-trocas'>
                    <Lottie animationData={bannerHome} loop={true} />
                </Link>
            </BoxAnimationBanner>
        ];

        if (selectedCar?.COMODATO) {
            slides.push(<Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />);

            if (selectedCar?.CODIGO_SEGURADORA && [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0) {
                slides.push(<Banner bannerImg={BannerClub} link='' onClick={() => setShowModalClube(true)} />)
            }
        } else {
            slides.push(...[
                <Banner bannerImg={isProductRF ? BannerUpgradeRf : BannerUpgrade} link={!blockClick && !selectedCar?.COMODATO ? '/central-de-trocas' : ''} />,
                <Banner bannerImg={BannerClub} link='' onClick={() => setShowModalClube(true)} />,
                <Banner bannerImg={BannerServicesAdd} link='/servicos-adicionais' />
            ]);
        }

        return slides;
    }

    const bannersMob = () => {
        const slides = [
            <BoxAnimationBanner>
                <Link to='/central-de-trocas'>
                    <Lottie animationData={bannerHomeMob} loop={true} style={{ height: '9.6rem' }} />
                </Link>
            </BoxAnimationBanner>
        ];

        if (selectedCar?.COMODATO) {
            slides.push(<Banner bannerImg={BannerDadosAtualizadosMob} link='/meus-dados' />);

            if (selectedCar?.CODIGO_SEGURADORA && [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0) {
                slides.push(<Banner bannerImg={BannerClubMb} link='' onClick={() => setShowModalClube(true)} />)
            }
        } else {
            slides.push(...[
                <Banner bannerImg={BannerUpgradeMb} link={!blockClick ? '/central-de-trocas' : ''} />,
                <Banner bannerImg={BannerClubMb} link='' onClick={() => setShowModalClube(true)} />,
                <Banner bannerImg={BannerServicesAddMb} link='/servicos-adicionais' />
            ]);
        }

        return slides;
    }

    useEffect(() => {
        selectedCar && handleSomeProductRF(selectedCar.CD_PRODUTO) ? setIsProductRF(true) : setIsProductRF(false);
    }, [selectedCar]);

    return (
        <Menu>
            <ContentBodyPage>
                <CarouselCars />
                <VehicleData />
                <ContentNewsMobile>
                    <NavTitle title='Fique ligado!' />
                    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                        <Carousel sx={{ width: '100%', 'button': { display: 'none' }, minHeight: '10.5rem' }} interval={9000}>
                            {bannersMob()}
                        </Carousel>
                    </Box>
                </ContentNewsMobile>
                <News />
            </ContentBodyPage>

            <ContentNewsPage>
                <Box sx={{
                    width: {
                        xs: '100%',
                        md: 'auto'
                    },
                    maxWidth: {
                        xs: '100%',
                        md: '95%'
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }}>
                    <Box sx={{
                        width: '100%',
                        display: {
                            xs: 'none',
                            md: 'block'
                        }
                    }}>
                        <NavTitle title='Fique ligado!' />
                        <Carousel sx={{ width: '100%', 'button': { display: 'none' }, height: '27.4rem' }} interval={9000}>
                            {bannersDesk()}
                        </Carousel>
                    </Box>

                    <Box sx={{ padding: '2rem 0 1rem', width: '100%' }}>
                        <NavTitle title='Atendimento' />
                        <LinkButton to='/atendimento'>
                            <IcRemoveDoubts />
                            TIRE SUAS DÚVIDAS
                        </LinkButton>
                    </Box>

                    <Box>
                        <NavTitle title='Ituran nas Redes Sociais' />
                        <Box sx={{
                            marginTop: '1rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            'svg': {
                                height: '1.625rem',
                                width: 'auto'
                            }
                        }}>
                            <a href="https://www.facebook.com/ituran.rastreador" target='blank'>
                                <IcFace />
                            </a>
                            <a href="https://www.instagram.com/ituranbrasil/" target='blank'>
                                <IcInsta />
                            </a>
                            <a href="https://www.youtube.com/user/RastreadorITURAN" target='blank'>
                                <IcYoutube />
                            </a>
                            <a href="https://blog.ituran.com.br/" target='blank'>
                                <IcBlog />
                            </a>
                        </Box>
                    </Box>
                </Box>
            </ContentNewsPage>
            <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
        </Menu >
    );
}

export default Home;